var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLivingTributeFour(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.00033 21.3327C14.667 21.3327 17.3337 10.666 24.0003 10.666C25.4148 10.666 26.7714 11.2279 27.7716 12.2281C28.7718 13.2283 29.3337 14.5849 29.3337 15.9993C29.3337 17.4138 28.7718 18.7704 27.7716 19.7706C26.7714 20.7708 25.4148 21.3327 24.0003 21.3327C17.3337 21.3327 14.667 10.666 8.00033 10.666C6.58584 10.666 5.22928 11.2279 4.22909 12.2281C3.2289 13.2283 2.66699 14.5849 2.66699 15.9993C2.66699 17.4138 3.2289 18.7704 4.22909 19.7706C5.22928 20.7708 6.58584 21.3327 8.00033 21.3327Z",
    stroke: "#2F4E77",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLivingTributeFour);
export default __webpack_public_path__ + "static/media/living-tribute-four.112bf5f68dbd0a76c1ae7956c7a0a731.svg";
export { ForwardRef as ReactComponent };